import ButtonIcon from "#common/buttons/ButtonIcon"
import { MasterDialog } from "#common/Dialog/Dialog"
import ByAtInfo from "#competence/components/ByAtInfo"
import ChipStatus from "#competence/components/ChipStatus"
import { UseContextsCompetence } from "#competence/contexts/ContextsCompetence"
import { UseContextsQuestion } from "#competence/contexts/ContextsQuestion"
import { preguntaIdGet } from "#competence/services/Api"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import CancelIcon from "@mui/icons-material/Cancel"
import EditIcon from "@mui/icons-material/Edit"
import { Box, Button, Chip, Divider, Skeleton, Stack, Typography } from "@mui/material"
import { Fragment, useCallback, useMemo } from "react"

export default function CompetenceQuestionInfo() {
	const { questionId, setQuestion, setOpen, reload } = UseContextsQuestion()
	const { competence } = UseContextsCompetence()
	const params = useMemo(() => ({ id: questionId }), [questionId])

	const {
		data: questions,
		loading,
		error,
	} = useApi(preguntaIdGet, { autoFetch: true, params, reload })

	const handleOpen = useCallback(
		(type) => {
			setQuestion(questions)
			setOpen(type)
		},
		[questions, setOpen, setQuestion]
	)
	if (loading) return <Skeleton variant="rectangular" height={100} />
	if (error) return <ErrorResponse />

	return (
		<Box>
			<Stack direction={"column"} spacing={2} alignContent={"center"}>
				<Box>
					<Typography>
						{questions.competencia_name}/{questions.type_name}
					</Typography>
					<Typography
						variant="h6"
						component="h3"
						gutterBottom
						fontWeight="600"
						color="text.primary"
					>
						{questions.question}
					</Typography>
					<Stack
						spacing={1}
						direction={"row"}
						alignItems={"center"}
						justifyContent={"space-between"}
					>
						<Stack direction={"row"} spacing={1}>
							<ChipStatus active={questions.active} />
						</Stack>
					</Stack>
				</Box>
				{questions.auxiliary && (
					<Box>
						<Typography
							variant="h6"
							component="h3"
							gutterBottom
							fontWeight="600"
							color="text.primary"
						>
							Preguntas auxiliares
						</Typography>
						<Typography
							variant="body2"
							textAlign="left"
							color="text.secondary"
							whiteSpace="pre-line"
							sx={{}}
						>
							{questions.auxiliary}
						</Typography>
					</Box>
				)}
				<ByAtInfo
					title="Creada Por"
					at={questions.created_at}
					name={questions.created_by_name}
				/>
				<ByAtInfo
					at={questions.updated_at}
					name={questions.updated_by_name}
					title="Actualizada Por"
				/>
				{questions.active && competence.active && (
					<Fragment>
						<Divider />
						<Stack
							direction={"row"}
							spacing={3}
							alignItems={"center"}
							alignContent={"center"}
							justifyContent={"center"}
						>
							<Button
								startIcon={<EditIcon />}
								onClick={() => {
									handleOpen("form")
								}}
							>
								Editar
							</Button>
							<Button
								startIcon={<CancelIcon />}
								onClick={() => {
									handleOpen("delete")
								}}
								color="error"
							>
								Desactivar
							</Button>
						</Stack>
					</Fragment>
				)}
			</Stack>
		</Box>
	)
}

export function CompetenceQuestionInfoDialog({ id }) {
	const { info, setInfo } = UseContextsQuestion()
	return (
		<MasterDialog {...{ open: info, setOpen: setInfo }} maxWidth="sm">
			<CompetenceQuestionInfo id={id} />
		</MasterDialog>
	)
}
